import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useApplication } from '../../AppContext';

const CreateRoom = ({ room, setRoom }) => {

	const { t } = useTranslation();
	const app = useApplication();

	const [code, setCode] = React.useState('');

	const handleCodeChange = React.useCallback((e) => {
		const val = e?.target?.value ?? '';
		setCode(val.toUpperCase());
	}, []);

	const handleJoinClick = React.useCallback((e) => {
		e?.preventDefault?.();
		e?.stopPropagation?.();

		(async () => {

			const result = await app.multiplayer.joinOrCreate(code, {
				playerName: app?.userdata?.name,
				name: app?.userdata?.name,
				avatar: app?.userdata?.avatar,
			});
			setRoom(result);
			setCode(result.roomId);
		})();
	}, [app, code, setRoom]);

	const interactionButton = React.useMemo(() => {
		if (room) {
			return null;
		}

		return (
			<a
				href="#"
				className="simpleButtonOutLine w-100"
				onClick={handleJoinClick}
			>
				{t('Enter')}
			</a>
		);
	}, [handleJoinClick, room, t]);

	return (
		<>
			<li>
				{t('Create or join an existing room')}
			</li>
			<li className="mb2">
				({t('4 letters or more')})
			</li>
			<li className="mb2">
				<input
					type="text"
					value={code}
					onChange={handleCodeChange}
					readOnly={!!room}
					placeholder={t('room name')}
					className="w-100"
				/>
			</li>
			<li className="mb2">
				{interactionButton}
			</li>
		</>
	);
};

export default CreateRoom;
